import { forceVersionReload } from './versionGuard';

const POLL_INTERVAL_MS = 10 * 60 * 1000;
const VERSION_META_REGEX = /<meta name="app-version" content="([^"]+)"/;

let pollTimer: ReturnType<typeof setInterval> | null = null;

async function checkForNewVersion(): Promise<void> {
	try {
		const response = await fetch('/', { cache: 'no-store' });
		const html = await response.text();
		const liveVersion = html.match(VERSION_META_REGEX)?.[1];

		if (liveVersion && liveVersion !== __APP_VERSION__) {
			forceVersionReload(liveVersion);
		}
	} catch {
		// Network hiccup or offline — retried on the next tick/focus.
	}
}

function handleVisibilityChange(): void {
	if (document.visibilityState === 'visible') checkForNewVersion();
}

// Starts a background check for new deployments while the tab stays open.
// Runs on a coarse interval plus whenever the tab regains focus/visibility —
// never while backgrounded, since nothing needs to interrupt a user who isn't
// looking at the tab.
export function startVersionPoll(): void {
	if (pollTimer) return;

	pollTimer = setInterval(checkForNewVersion, POLL_INTERVAL_MS);
	document.addEventListener('visibilitychange', handleVisibilityChange);
	window.addEventListener('focus', checkForNewVersion);
}
